<template>
<div class="chapter">
<div class="inner_page">
<p style="font-weight: bold; page-break-before: always; text-align: center; text-indent: 0">DEDICATION</p>
<p class="section-break">––––––––</p><div class="decoration-scene-break"><div class="decoration-scene-break-inner"><img alt="image" class="decoration-scene-break" src="d2d_images/scene_break.png"/></div></div>
<p class="first-in-scene" style="text-align: justify"><span style="font-size: x-large"><span class="first-scene-phrase"><span class="first-in-scene character-t">T</span></span></span>o Jenny, Lisa, Lucy, and all the girls who sent me handwritten letters about angels, life, and my books. Thank you for helping me write the books you love to read by telling me what you love best about them. </p>
<p style="font-size: x-large; page-break-before: always; text-align: center; text-indent: 0">Prologue</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c003.vue?a4d97170